import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import ReportList from './Report/ReportList';
import CapPlanningDetail from './Dashboard';

export default function CapitalPlanning({ match }) {
  return (
    <div className="content">
      <div className="container-fluid">
        <Route path={`${match.url}/dashboard`} component={CapPlanningDetail} />
        <Route path={`${match.url}/report`} component={ReportList} />
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/pages/CapitalPlanning/index.js